import { getAxiosInstance } from '../utils/axios-api';
import { getAccessToken } from '../utils/customMethods';
import { notify } from '../utils/notifications/notifications';
import moment from 'moment';

export const getInvoiceReport= (obj,type) => async dispatch => {
    try {
        let search=`docType=${type}&`;;
        if((obj.projectId||0)!==0 && obj.projectId!==''){
            search+=`projectId=${obj.projectId}&`;
        }
        if((obj.milestoneRecId||0)!==0 && obj.milestoneRecId!==''){
            search+=`milestoneRecId=${obj.milestoneRecId}&`;
        }
        if((obj.cmId||0)!==0 && obj.cmId!==''){
            search+=`cmId=${obj.cmId}&`;
        }
        if((obj.onboardingTypeId||0)!==0 && obj.onboardingTypeId!==''){
            search+=`onboardingTypeId=${obj.onboardingTypeId}&`;
        }
        if(moment(obj.yearMonth).isValid()){
            search+=`yearMonth=${moment(obj.yearMonth).format('YYYYMM')}&`;
        }
      const response = await getAxiosInstance()({
       url: `/invoice?${search}access_token=${getAccessToken()}`,
       method:'get',
       responseType: 'blob',
      });
  
      return response.status === 200 ? response :{};
    } catch (ex) {
        notify('error',"Something went wrong. Please try again");
        return {};
    }
  };